import React, { FC } from 'react'
import { ArticleProps } from './Article.types'
import {
  articleInnerConstrainedClasses,
  articleInnerVertPadding,
  setArticleLayoutSize,
} from './utils/setCssClasses'
import { Compounds } from '../Compounds'
import {
  setBackgroundImage,
  setBgContrastClass,
  setConfigBgColorClass,
  setConfigVertSpacing,
} from '../../utils/layout-util'
import { RTECompound } from '../Compounds/src/RTECompound'
import './article.scss'
import { AnchorLinks } from '../AnchorLinks'
import { ErrorBoundary } from '../ErrorBoundary/src'

export const Article: FC<ArticleProps> = props => {
  const {
    title,
    description,
    contents,
    brandExtension,
    introduction,
    layoutConfigs,
    anchorIdentifier,
    dataAnalytics,
    displayName,
    anchorLinksList,
    bannerBackgroundImage,
  } = props.content
  const backgroundColor = setConfigBgColorClass(layoutConfigs)
  const setBackgroundColor = backgroundColor
    ? `${backgroundColor} ${setBgContrastClass(layoutConfigs)} `
    : 'noBgColor'
  const contentAlignment = (align?: string) => {
    if (align == 'Right') {
      return 'u-flexJustifyEnd' + ' u-flex'
    } else if (align == 'Center') {
      return 'u-flexJustifyCenter' + ' u-flex'
    } else if (align == 'Default') {
      return ''
    } else {
      return ' u-flex'
    }
  }

  const articleContent = contents?.map(content => {
    return (
      <section className='Content' key={content.identifier}>
        {content?.anchorlinks?.sectionTitle && (
          <h2
            className={`${setArticleLayoutSize(
              layoutConfigs
            )} u-sm-sizeFull u-sm-marginLeft0" id="${content.anchorlinks.sectionAnchorlink}`}
          >
            {content.anchorlinks.sectionTitle}
          </h2>
        )}
        {content.blocks && (
          <div
            className={`${setArticleLayoutSize(
              layoutConfigs
            )} u-marginCenter u-sm-sizeFull u-sm-marginLeft0 ${
              content.alignment ? contentAlignment(content.alignment) : ''
            } ${
              content.divider && content.divider === 'true'
                ? 'divider u-marginBottom20 u-paddingBottom8 u-borderVert u-borderColorNeutral u-borderTop0'
                : layoutConfigs?.innerVerticalSpacing
                ? 'u-marginBottom0'
                : 'u-marginBottom24'
            }`}
          >
            <ErrorBoundary>
              <Compounds {...content.blocks} />
            </ErrorBoundary>
          </div>
        )}
      </section>
    )
  })

  return (
    <>
      {(bannerBackgroundImage || setBackgroundImage(layoutConfigs)) && (
        <style
          type='text/css'
          dangerouslySetInnerHTML={{
            __html: `
        #${anchorIdentifier}.article-banner-bg.u-bgSizeCover { background: url("${
              bannerBackgroundImage || setBackgroundImage(layoutConfigs)
            }"); }
      `,
          }}
        />
      )}
      <section
        className={`Article ${setConfigVertSpacing(layoutConfigs)} ${
          bannerBackgroundImage || setBackgroundImage(layoutConfigs)
            ? 'article-banner-bg u-bgSizeCover'
            : ''
        } ${brandExtension}`}
        id={anchorIdentifier}
        data-analytics={dataAnalytics ?? 'article'}
        data-analytics-component-name='Article'
        data-analytics-content-document-name={displayName}
        data-testid={'Article'}
      >
        <div className={` ${setBackgroundColor} ${introduction?.content ? 'has-intro' : ''}`}>
          <div
            className={`${articleInnerConstrainedClasses(layoutConfigs)}  ${articleInnerVertPadding(
              layoutConfigs
            )}`}
          >
            <div className='u-posRelative'>
              <div
                className={`Content ${setArticleLayoutSize(
                  layoutConfigs
                )} u-sm-sizeFull u-sm-marginLeft0 u-sm-paddingHoriz20`}
              >
                {title && <h2 id={title}>{title}</h2>}

                {introduction?.content && (
                  <div className='Content u-paddingBottom32'>
                    <RTECompound {...introduction} />
                  </div>
                )}
              </div>
            </div>
            <div className={`Content u-sizeFull u-sm-paddingHoriz20 u-posRelative`}>
              {description?.content && (
                <div
                  className={`${setArticleLayoutSize(
                    layoutConfigs
                  )} u-sm-sizeFull u-sm-marginLeft0 u-paddingBottom32 u-marginCenter `}
                >
                  <RTECompound {...description} />
                </div>
              )}
              {anchorLinksList && <AnchorLinks {...anchorLinksList} />}
              {articleContent}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
